module.exports = __webpack_public_path__ + "static/media/Big Launch.394d800b.gif";